import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckoutComponent } from './checkout/checkout.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { SignupComponent } from 'src/app/components/pages/signup/signup.component';
import { ApplicationComponent } from './application/application.component';
import { AuthGuard } from '../shared/services/auth.guard.service';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { OrderInvoiceComponent } from './order-invoice/order-invoice.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ShippingAddressComponent } from './shippingaddress/shippingaddress.component';
import { CompleteComponent } from './complete/complete.component';
import { LoggedInAuthGuard } from '../shared/services/loggedin.guard.service';
import { ContactComponent } from './contacts/contacts.component';
import { FlickityComponent } from './flickity/flickity.component';
import { LoyaltyRewardsComponent } from './loyalty-rewards/loyalty-rewards.component';
import { MembershipComponent } from './membership/member.component';
import { ShopproductsComponent } from './shopproducts/shopproducts.component';
import { ScienceIngredientsComponent } from './science-ingredients/science-ingredients.component';
import { SuccessStoriesComponent } from './success-stories/success-stories.component';
import { OurStoryComponent } from './our-story/our-story.component';
import { ShopnowComponent } from './shopnow/shopnow.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { RewardPlanComponent } from './reward-plan/reward-plan.component';
import { homeComponent } from './home/home.component';
import { BrainMoodAndEnergyComponent } from './brain-mood-and-energy/brain-mood-and-energy.component';
import { ManageAutoshipComponent } from './manage-autoship/manage-autoship.component';
import { AboutUsComponent } from './aboutus/aboutus.component';
import { AutoshipPageComponent } from './autoship-page/autoship-page.component';
import { AutoshipDetailPageComponent } from './autoship-detail-page/autoship-detail-page.component';
import { BlogDetailComponent } from "../blog/blog-detail/blog-detail.component";
import { WelcomeComponent } from '../welcome/welcome.component';

const routes: Routes = [
      { path: 'home', component: homeComponent },
      { path: 'checkout', component: CheckoutComponent,canActivate: [AuthGuard] },
      // { path: 'contact', component: ContactComponent },
      { path: 'orderhistory', component: OrderHistoryComponent,canActivate: [AuthGuard] },
      { path: 'manageautoship', component: ManageAutoshipComponent,canActivate: [AuthGuard] },
      { path: 'complete', component: CompleteComponent},
      { path: '404', component: ErrorPageComponent },
      { path: 'signup', component: SignupComponent ,canActivate: [LoggedInAuthGuard]},
      { path: 'join', component: ApplicationComponent },
      { path: 'orderinvoice', component: OrderInvoiceComponent ,canActivate: [AuthGuard] },
      { path: 'forgotpassword', component: ForgotPasswordComponent },
      { path: 'shipping', component: ShippingAddressComponent,canActivate: [AuthGuard] },
      { path: 'item/:id', component: FlickityComponent},
      { path: 'loyalty-rewards', component: LoyaltyRewardsComponent},
      { path: 'membership', component: MembershipComponent},
      { path: 'shop1', component:ShopproductsComponent},
      { path: 'shop', component:ShopnowComponent},
      { path: 'discover-more', component:ShopnowComponent},
      { path: 'product', component:ProductDetailsComponent},
      { path: 'product/:id', component:ProductDetailsComponent},
      // { path: 'homenew', component:HomeNewComponent},
      { path: 'science-ingredients', component:ScienceIngredientsComponent},
      { path: 'success-stories', component:SuccessStoriesComponent},
      { path: "success-stories/:slug", component: BlogDetailComponent },
      { path: "success-stories/**", redirectTo: "home" },
      { path: 'contact', component:AboutUsComponent},
      { path: 'reward-plan', component:RewardPlanComponent},
      { path: 'brain-mood-and-energy', component:BrainMoodAndEnergyComponent},
      { path: 'essential-oils', component:BrainMoodAndEnergyComponent},
      { path: 'immune-and-cardiovascular', component:BrainMoodAndEnergyComponent},
      { path: 'men-and-womens-health', component:BrainMoodAndEnergyComponent},
      { path: 'muscle-bone-and-joint', component:BrainMoodAndEnergyComponent},
      { path: 'skin-and-beauty', component:BrainMoodAndEnergyComponent},
      { path: 'whycs', component:OurStoryComponent},
      { path: 'autoship', component:AutoshipPageComponent},
      { path: 'autoshiping', component:AutoshipDetailPageComponent},      
      { path: 'autoshiping/:id', component:AutoshipDetailPageComponent},      
      { path: 'welcome', component: WelcomeComponent },
      { path: 'account', loadChildren: () => import('./account-details/account-details.module').then(m => m.AccountDetailsModule) }
    ];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
